import { Gift } from "lucide-react";

export const PromoBanner = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-emerald-600 text-white text-center py-2 px-4 text-sm font-medium">
      <div className="flex items-center justify-center gap-2">
        <Gift className="h-4 w-4" />
        <span>Christmas offer – 10% off all orders with code <strong>XMAS10</strong></span>
      </div>
    </div>
  );
};

// Export the banner height for other components to use
export const PROMO_BANNER_HEIGHT = 36; // px
